import Footer from "app/pages/.shared/Footer/Footer";

import "./footer.scss";

const BrandFooter = props => <Footer {...props} />;
export default BrandFooter;
